import { Box, CircularProgress, Tab, Tabs } from '@mui/material'
import SwipeableDrawerRightDialog from '../../../../components/Dialogs/SwipeableDrawerRightDialog'
import { maskMoney, maskPercentage } from '../../../../masks/masks'
import React, { useCallback, useEffect, useRef } from 'react'
import { TIndicatedTenantItem } from '../../../../core/types/IndicatedTenant'
import IndicatedController from '../../../../core/controllers/IndicatedController'
import Hosts from '../../../../core/functions/hosts'
import { useTenantSettingsByTenantId } from '../../../../core/hooks/useTenantSettingsByTenantId'
import { a11yProps, TabPanel } from '../../../../components/Tabs'
import { TDataTablePagination } from '../../../../components/Tables/DataTable'
import UserSettingGeneral from './Tabs/UserSettingGeneral'
import UserSettingValues from './Tabs/UserSettingValues'
import UserSettingIndicated from './UserSettingIndicated'
import MyProducts from '../../../Products/MyProducts'
import { UserSettingProps } from './UserSettingTypes'
import UserSettingWidgets from './UserSettingColumns'
import UserSettingIndicateds from './Tabs/UserSettungIndicateds'
import UserSettingFunctions from './UserSettingFunctions'
import UserSettingAffiliateds from './Tabs/UserSettingAffiliateds'
import UserSettingSecurity from './Tabs/UserSettingSecurity'
import NumberFunctions from '../../../../core/functions/NumberFunctions'
import TenantFunctions from '../../../../core/functions/TenantFunctions'
import {
  USER_SETTING_TAB_AFFILIATEDS,
  USER_SETTING_TAB_EXTRACT,
  USER_SETTING_TAB_GENERAL,
  USER_SETTING_TAB_INDICATEDS,
  USER_SETTING_TAB_PRODUCTS,
  USER_SETTING_TAB_SECURITY,
  USER_SETTING_TAB_VALUES,
} from './UserSettingConsts'
import UserSettingExtract from './Tabs/UserSettingExtract'
import { useAdminUserContext } from '../../../../core/hooks/useAdminUserContext'

const UserSetting = ({
  open,
  sending,
  handleClose,
  handleSave,
  setOpen,
  setSending,
  setSuccess,
  setError,
  setMessage,
  executeUserSettings,
}: UserSettingProps) => {
  const { tenantSettings, setTenantSettings } = useAdminUserContext()

  const [errorTenant, setErrorTenant] = React.useState('')
  const [errorImmediateWithdrawal, setErrorImmediateWithdrawal] =
    React.useState('')
  const [errorAnticipationD15Fee, setErrorAnticipationD15Fee] =
    React.useState('')
  const [errorAnticipationD7Fee, setErrorAnticipationD7Fee] = React.useState('')
  const [errorAnticipationD2Fee, setErrorAnticipationD2Fee] = React.useState('')
  const [errorIndicatedValue, setErrorIndicatedValue] = React.useState('')
  const [errorCurrentIndicatedValue, setErrorCurrentIndicatedValue] =
    React.useState('')
  const [errorAffiliateFee, setErrorAffiliateFee] = React.useState('')

  const [errorMaxCardAttemptsPerHour, setErrorMaxCardAttemptsPerHour] =
    React.useState('')
  const [errorCardAttemptsWindowInMinutes, setErrorCardAttemptsWindowInMinutes] =
    React.useState('')
  const [errorMaxDocumentTransactionsPerDay, setErrorMaxDocumentTransactionsPerDay] =
    React.useState('')
  const [errorDocumentTransactionsWindowInHours, setErrorDocumentTransactionsWindowInHours] =
    React.useState('')
  const [errorConsecutiveCardDeclinesToBlock, setErrorConsecutiveCardDeclinesToBlock] =
    React.useState('')
  const [errorCardTemporaryBlockMinutes, setErrorCardTemporaryBlockMinutes] =
    React.useState('')
  const [errorDailyCardAmountLimit, setErrorDailyCardAmountLimit] =
    React.useState('')
  const [errorWithdrawLimit, setErrorWithdrawLimit] = React.useState('')

  const [loading, setLoading] = React.useState(false)

  const [tabIndex, setTabIndex] = React.useState(0)

  const [indicateds, setIndicateds] = React.useState<TIndicatedTenantItem[]>([])
  const [currentIndicated, setCurrentIndicated] =
    React.useState<TIndicatedTenantItem | null>(null)

  const id = useRef('')

  const recipientUrl = TenantFunctions.getTenantRecipientUrl(
    tenantSettings?.recipientId
  )

  const dataPagination: TDataTablePagination<TIndicatedTenantItem> = {
    items: indicateds,
    page: 0,
    rowsPerPage: 0,
    total: 0,
    totalPages: 0,
  }

  const { data: settings, loading: loadingSettings, execute: executeSettingsRefresh } =
    useTenantSettingsByTenantId({
      id: tenantSettings?.tenantId ?? '',
      requestRecipient: true,
    })

  const getIndicatedList = useCallback(
    async (id: string) => {
      UserSettingFunctions.getIndicatedList({
        id,
        setLoading,
        setError,
        setIndicateds,
      })
    },
    [setLoading, setError, setIndicateds]
  )

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue)
    if (newValue === USER_SETTING_TAB_INDICATEDS) {
      getIndicatedList(tenantSettings?.tenantId ?? '')
    }
  }

  const handleChangeSave = () => {
    var error = false

    if (!tenantSettings) {
      setError('Erro ao salvar configurações')
      return
    }

    if ((tenantSettings?.tenantId ?? '') === '') {
      setErrorTenant('Campo obrigatório')
      error = true
    }

    const immediateWithdrawal = maskPercentage(
      tenantSettings?.immediateWithdrawal
    )
      .replaceAll('.', '')
      .replaceAll(',', '.')
    tenantSettings.immediateWithdrawal = Number(immediateWithdrawal)
    if (tenantSettings.immediateWithdrawal > 90) {
      setTabIndex(USER_SETTING_TAB_VALUES)
      setErrorImmediateWithdrawal('O valor precisa ser no máximo 90%')
      error = true
    }

    if (tenantSettings.enableAnticipationD15) {
      const anticipationD15Fee = tenantSettings.anticipationD15Fee ?? 0
      if (anticipationD15Fee <= 0 || anticipationD15Fee > 5) {
        setTabIndex(USER_SETTING_TAB_VALUES)
        setErrorAnticipationD15Fee(
          'O valor precisa ser maior que zero (0%) e menor que cinco (5%)'
        )
        error = true
      }
    }

    if (tenantSettings.enableAnticipationD7) {
      const anticipationD7Fee = tenantSettings.anticipationD7Fee ?? 0
      if (anticipationD7Fee <= 0 || anticipationD7Fee > 5) {
        setTabIndex(USER_SETTING_TAB_VALUES)
        setErrorAnticipationD7Fee(
          'O valor precisa ser maior que zero (0%) e menor que cinco (5%)'
        )
        error = true
      }
    }

    if (tenantSettings.enableAnticipationD2) {
      const anticipationD2Fee = tenantSettings.anticipationD2Fee ?? 0
      if (anticipationD2Fee <= 0 || anticipationD2Fee > 5) {
        setTabIndex(USER_SETTING_TAB_VALUES)
        setErrorAnticipationD2Fee(
          'O valor precisa ser maior que zero (0%) e menor que cinco (5%)'
        )
        error = true
      }
    }

    const indicatedComissionsRateValue = maskPercentage(
      tenantSettings.indicatedComissionsRateValue ?? '0'
    )
      .replaceAll('.', '')
      .replaceAll(',', '.')
    tenantSettings.indicatedComissionsRateValue = Number(
      indicatedComissionsRateValue
    )
    if (tenantSettings.indicatedComissionsRateValue > 30) {
      if (tenantSettings.disableIndicatedComissions) {
        tenantSettings.indicatedComissionsRateValue = 0
      } else {
        setTabIndex(USER_SETTING_TAB_INDICATEDS)
        setErrorIndicatedValue('O valor precisa ser no máximo 30%')
        error = true
      }
    }

    if (tenantSettings.enableAffiliateFees) {
      const affiliateFees = maskPercentage(tenantSettings.affiliateFees ?? '0')
        .replaceAll('.', '')
        .replaceAll(',', '.')
      tenantSettings.affiliateFees = Number(affiliateFees)

      if (tenantSettings.affiliateFees <= 0) {
        setErrorAffiliateFee('O valor precisa ser maior que zero (0%)')
        setTabIndex(USER_SETTING_TAB_AFFILIATEDS)
        error = true
      }
      if (tenantSettings.affiliateFees > 90) {
        setErrorAffiliateFee('O valor precisa ser no máximo 90%')
        setTabIndex(USER_SETTING_TAB_AFFILIATEDS)
        error = true
      }
    }

    if (tenantSettings.withdrawLimitEnabled) {
      tenantSettings.withdrawLimit = NumberFunctions.maskMoneyToNumber(
        maskMoney(tenantSettings.withdrawLimit ?? 0)
      )
      if (tenantSettings.withdrawLimit <= 0) {
        setTabIndex(USER_SETTING_TAB_GENERAL)
        setErrorWithdrawLimit(
          'Informe o valor do limite ao habilitar a restrição de saque.'
        )
        error = true
      }
    }

    if (tenantSettings.enableVelocityCheck) {
      const maxCardAttempts = tenantSettings.maxCardAttemptsPerHour ?? 3
      if (maxCardAttempts < 1 || maxCardAttempts > 100) {
        setTabIndex(USER_SETTING_TAB_SECURITY)
        setErrorMaxCardAttemptsPerHour('O valor precisa ser entre 1 e 100')
        error = true
      }

      const cardWindow = tenantSettings.cardAttemptsWindowInMinutes ?? 60
      if (cardWindow < 1 || cardWindow > 1440) {
        setTabIndex(USER_SETTING_TAB_SECURITY)
        setErrorCardAttemptsWindowInMinutes(
          'O valor precisa ser entre 1 e 1440 minutos'
        )
        error = true
      }

      const maxDocTx = tenantSettings.maxDocumentTransactionsPerDay ?? 5
      if (maxDocTx < 1 || maxDocTx > 1000) {
        setTabIndex(USER_SETTING_TAB_SECURITY)
        setErrorMaxDocumentTransactionsPerDay(
          'O valor precisa ser entre 1 e 1000'
        )
        error = true
      }

      const docWindow =
        tenantSettings.documentTransactionsWindowInHours ?? 24
      if (docWindow < 1 || docWindow > 168) {
        setTabIndex(USER_SETTING_TAB_SECURITY)
        setErrorDocumentTransactionsWindowInHours(
          'O valor precisa ser entre 1 e 168 horas'
        )
        error = true
      }

      const consecutiveDeclines =
        tenantSettings.consecutiveCardDeclinesToBlock ?? 2
      if (consecutiveDeclines < 1 || consecutiveDeclines > 20) {
        setTabIndex(USER_SETTING_TAB_SECURITY)
        setErrorConsecutiveCardDeclinesToBlock(
          'O valor precisa ser entre 1 e 20'
        )
        error = true
      }

      const blockMinutes = tenantSettings.cardTemporaryBlockMinutes ?? 30
      if (blockMinutes < 1 || blockMinutes > 1440) {
        setTabIndex(USER_SETTING_TAB_SECURITY)
        setErrorCardTemporaryBlockMinutes(
          'O valor precisa ser entre 1 e 1440 minutos'
        )
        error = true
      }

      tenantSettings.dailyCardAmountLimit = NumberFunctions.maskMoneyToNumber(
        maskMoney(tenantSettings.dailyCardAmountLimit ?? 2000)
      )
      const dailyLimit = tenantSettings.dailyCardAmountLimit
      if (dailyLimit < 1 || dailyLimit > 1000000) {
        setTabIndex(USER_SETTING_TAB_SECURITY)
        setErrorDailyCardAmountLimit(
          'O valor precisa ser entre R$ 1,00 e R$ 1.000.000,00'
        )
        error = true
      }
    }

    if (error) {
      return
    }

    handleSave()
  }

  const handleEnableOrDisableIndicatedComission = async (
    item: TIndicatedTenantItem
  ) => {
    UserSettingFunctions.enableOrDisableIndicated({
      data: {
        indicationOfId: tenantSettings?.tenantId ?? '',
        tenantId: item.tenantId,
        value: !item.isEnableCommissions,
      },
      setSending,
      setError,
      setSuccess,
      setLoading,
      setIndicateds,
    })
  }

  const handleCloseIndicated = () => {
    setErrorCurrentIndicatedValue('')
    setCurrentIndicated(null)
  }

  const handleOpenIndicated = (value: boolean) => {
    setErrorCurrentIndicatedValue('')
    if (!value) {
      handleCloseIndicated()
    }
  }

  const handleSaveIndicated = async () => {
    setErrorCurrentIndicatedValue('')
    if (!currentIndicated) {
      setError('Nenhum indicado selecionado')
      return
    }

    const indicatedComissionsPercentage = maskPercentage(
      currentIndicated.indicatedComissionsPercentage ?? '0'
    )
      .replaceAll('.', '')
      .replaceAll(',', '.')
    currentIndicated.indicatedComissionsPercentage = Number(
      indicatedComissionsPercentage
    )
    if (currentIndicated.indicatedComissionsPercentage > 30) {
      if (!currentIndicated.isEnableCommissions) {
        currentIndicated.indicatedComissionsPercentage = 0
      } else {
        setErrorCurrentIndicatedValue('O valor precisa ser no máximo 30%')
        return
      }
    }

    setSending(true)
    try {
      let response = await IndicatedController.updateIndicatedTenant({
        data: {
          tenantId: currentIndicated.tenantId,
          comissionsPercentage: currentIndicated.indicatedComissionsPercentage,
          indicatedComissionLevelEnum:
            currentIndicated.indicatedComissionLevelEnum,
          receiveComissionUntilDateOf:
            currentIndicated.receiveComissionUntilDateOf,
        },
      })
      if (!response.success) {
        setError(response.error)
      } else {
        setSuccess(true)
        handleCloseIndicated()
        getIndicatedList(tenantSettings?.tenantId ?? '')
      }
    } finally {
      setSending(false)
    }
  }

  const handleChangeCopyRecipientId = async () => {
    await Hosts.copyTextToClipboard(tenantSettings?.recipientId ?? '')
    setMessage('Código do recebedor copiado')
  }

  const handleOpenRecipient = () => {
    Hosts.openNewBlank(recipientUrl)
  }

  const handleChangeImmediateWithdrawal = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (!tenantSettings) {
      return
    }

    setErrorImmediateWithdrawal('')
    const immediateWithdrawal = NumberFunctions.maskPercentageToNumber(
      e.target.value
    )
    setTenantSettings({ ...tenantSettings, immediateWithdrawal })
  }

  const handleChangeIndicatedComissionsRateValue = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (!tenantSettings) {
      return
    }

    setErrorIndicatedValue('')
    const indicatedComissionsRateValue = NumberFunctions.maskPercentageToNumber(
      e.target.value
    )
    setTenantSettings({ ...tenantSettings, indicatedComissionsRateValue })
  }

  const handleChangeSalesEnabled = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!tenantSettings) {
      return
    }

    UserSettingFunctions.setSalesEnabled({
      salesEnabled: e.target.checked,
      tenantSettings,
      setSending,
      setError,
      setSuccess,
      setTenantSettings,
      executeUserSettings,
    })
  }

  const handleChangeWithdrawlsEnabled = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!tenantSettings) {
      return
    }

    UserSettingFunctions.setWithdrawlsEnabled({
      withdrawlsEnabled: e.target.checked,
      tenantSettings,
      setSending,
      setError,
      setSuccess,
      setTenantSettings,
      executeUserSettings,
    })
  }

  const handleChangeEnableRegisterProducts = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!tenantSettings) {
      return
    }

    UserSettingFunctions.enableRegisterProducts({
      enabled: e.target.checked,
      tenantSettings,
      setSending,
      setError,
      setSuccess,
      setTenantSettings,
      executeUserSettings,
    })
  }

  const handleChangeRequestValidationForProducts = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!tenantSettings) {
      return
    }

    UserSettingFunctions.enableRequestValidationForProducts({
      enabled: e.target.checked,
      tenantSettings,
      setSending,
      setError,
      setSuccess,
      setTenantSettings,
      executeUserSettings,
    })
  }

  const handleChangeClose = () => {
    setTabIndex(USER_SETTING_TAB_GENERAL)
    handleClose()
  }

  const columns = UserSettingWidgets.getUserSettingColumns({
    handleEnableOrDisableIndicatedComission,
    setCurrentIndicated,
  })

  useEffect(() => {
    if (!tenantSettings) {
      return
    }

    if (tenantSettings.id !== id.current) {
      id.current = tenantSettings.id
      setTabIndex(USER_SETTING_TAB_GENERAL)
    }
  }, [tenantSettings])

  return (
    <SwipeableDrawerRightDialog
      open={open}
      onClose={handleChangeClose}
      setOpen={setOpen}
      title="Configurações do usuário"
      subtitle={`${tenantSettings?.tenantName} (${tenantSettings?.tenantEmail})`}
      buttons={[
        { title: 'Cancelar', onClick: handleChangeClose, type: 'negative' },
        { title: 'Salvar', onClick: handleChangeSave, type: 'positive' },
      ]}
      buttonsDisabled={sending}
    >
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={tabIndex}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="basic tabs example"
          >
            <Tab label="Geral" {...a11yProps(USER_SETTING_TAB_GENERAL)} />
            <Tab label="Valores" {...a11yProps(USER_SETTING_TAB_VALUES)} />
            <Tab
              label="Indicados"
              {...a11yProps(USER_SETTING_TAB_INDICATEDS)}
            />
            <Tab label="Produtos" {...a11yProps(USER_SETTING_TAB_PRODUCTS)} />
            <Tab
              label="Afiliados"
              {...a11yProps(USER_SETTING_TAB_AFFILIATEDS)}
            />
            <Tab label="Extrato" {...a11yProps(USER_SETTING_TAB_EXTRACT)} />
            <Tab label="Segurança" {...a11yProps(USER_SETTING_TAB_SECURITY)} />
          </Tabs>
        </Box>
        <TabPanel value={tabIndex} index={USER_SETTING_TAB_GENERAL}>
          <UserSettingGeneral
            settings={settings}
            loadingSettings={loadingSettings}
            errorWithdrawLimit={errorWithdrawLimit}
            setErrorWithdrawLimit={setErrorWithdrawLimit}
            handleChangeCopyRecipientId={handleChangeCopyRecipientId}
            handleOpenRecipient={handleOpenRecipient}
            handleChangeSalesEnabled={handleChangeSalesEnabled}
            handleChangeWithdrawlsEnabled={handleChangeWithdrawlsEnabled}
            handleChangeEnableRegisterProducts={
              handleChangeEnableRegisterProducts
            }
            handleChangeRequestValidationForProducts={
              handleChangeRequestValidationForProducts
            }
          />
        </TabPanel>
        <TabPanel value={tabIndex} index={USER_SETTING_TAB_VALUES}>
          <UserSettingValues
            errorAnticipationD15Fee={errorAnticipationD15Fee}
            errorAnticipationD7Fee={errorAnticipationD7Fee}
            errorAnticipationD2Fee={errorAnticipationD2Fee}
            errorImmediateWithdrawal={errorImmediateWithdrawal}
            errorIndicatedValue={errorIndicatedValue}
            setErrorAnticipationD2Fee={setErrorAnticipationD2Fee}
            setErrorAnticipationD7Fee={setErrorAnticipationD7Fee}
            setErrorAnticipationD15Fee={setErrorAnticipationD15Fee}
            handleChangeImmediateWithdrawal={handleChangeImmediateWithdrawal}
            handleChangeIndicatedComissionsRateValue={
              handleChangeIndicatedComissionsRateValue
            }
          />
        </TabPanel>
        <TabPanel value={tabIndex} index={USER_SETTING_TAB_INDICATEDS}>
          {loading && <CircularProgress />}
          {!loading && (
            <UserSettingIndicateds
              indicateds={indicateds}
              dataPagination={dataPagination}
              columns={columns}
            />
          )}
        </TabPanel>
        <TabPanel
          value={tabIndex}
          index={USER_SETTING_TAB_PRODUCTS}
          sx={{ pt: 2 }}
        >
          <MyProducts tenantId={tenantSettings?.tenantId} />
        </TabPanel>
        <TabPanel value={tabIndex} index={USER_SETTING_TAB_AFFILIATEDS}>
          <UserSettingAffiliateds
            errorAffiliateFee={errorAffiliateFee}
            setErrorAffiliateFee={setErrorAffiliateFee}
          />
        </TabPanel>
        <TabPanel value={tabIndex} index={USER_SETTING_TAB_EXTRACT}>
          <UserSettingExtract />
        </TabPanel>
        <TabPanel value={tabIndex} index={USER_SETTING_TAB_SECURITY}>
          <UserSettingSecurity
            errorMaxCardAttemptsPerHour={errorMaxCardAttemptsPerHour}
            errorCardAttemptsWindowInMinutes={errorCardAttemptsWindowInMinutes}
            errorMaxDocumentTransactionsPerDay={errorMaxDocumentTransactionsPerDay}
            errorDocumentTransactionsWindowInHours={errorDocumentTransactionsWindowInHours}
            errorConsecutiveCardDeclinesToBlock={errorConsecutiveCardDeclinesToBlock}
            errorCardTemporaryBlockMinutes={errorCardTemporaryBlockMinutes}
            errorDailyCardAmountLimit={errorDailyCardAmountLimit}
            setErrorMaxCardAttemptsPerHour={setErrorMaxCardAttemptsPerHour}
            setErrorCardAttemptsWindowInMinutes={setErrorCardAttemptsWindowInMinutes}
            setErrorMaxDocumentTransactionsPerDay={setErrorMaxDocumentTransactionsPerDay}
            setErrorDocumentTransactionsWindowInHours={setErrorDocumentTransactionsWindowInHours}
            setErrorConsecutiveCardDeclinesToBlock={setErrorConsecutiveCardDeclinesToBlock}
            setErrorCardTemporaryBlockMinutes={setErrorCardTemporaryBlockMinutes}
            setErrorDailyCardAmountLimit={setErrorDailyCardAmountLimit}
          />
        </TabPanel>

        <UserSettingIndicated
          currentIndicated={currentIndicated}
          errorCurrentIndicatedValue={errorCurrentIndicatedValue}
          sending={sending}
          setCurrentIndicated={setCurrentIndicated}
          setErrorIndicatedValue={setErrorIndicatedValue}
          handleCloseIndicated={handleCloseIndicated}
          handleOpenIndicated={handleOpenIndicated}
          handleSaveIndicated={handleSaveIndicated}
        />
      </Box>
    </SwipeableDrawerRightDialog>
  )
}

export default UserSetting
